import React from "react";
import { useTranslation } from "react-i18next";
import { useBreakpoint } from "../../custom-hooks/useBreakpoint";
import CourseCard from "../CourseCard";
import Button from "../ui/Button";
import { ButtonVariant } from "../../types/constants";
import { useNavigate } from "react-router-dom";
import { courseServiceFactory } from "../../services/CourseServiceImpl";
import { useQuery } from "@tanstack/react-query";
import LoadingPanel from "../../custom-components/CustomLoader";
import { ICourseFlat } from "../../domain/models/Course";

const courseService = courseServiceFactory();

export default function EducationalMaterialsRightPanel() {
    const { t } = useTranslation();
    const { isTablet, isMobile } = useBreakpoint();
    const { i18n } = useTranslation();
    const navigate = useNavigate();

    const {
        data: coursesData,
        isLoading,
        error,
    } = useQuery({
        queryKey: ["courses", "educational", i18n.language],
        queryFn: async () => {
            const result = await courseService.getAllCourses(1, 6);
            return result;
        },
    });

    const courses = coursesData?.rows || [];
    let visibleCount = 3;
    if (isMobile) visibleCount = 1;
    else if (isTablet) visibleCount = 2;
    const visibleCourses = courses.slice(0, visibleCount);

    if (isLoading) {
        return <LoadingPanel isVisible={isLoading} />;
    }

    if (error || courses.length === 0) {
        return null;
    }

    return (
        <section className="w-full flex flex-col gap-[32px]">
            <h2 className="font-geologica text-2xl md:text-[36px] font-medium leading-[100%] uppercase text-primary-400 py-[12px]">
                {t("educationalMaterials.courses.title")}
            </h2>
            <div
                className={`grid gap-[24px] justify-items-center md:justify-items-start lap:justify-items-start ${isMobile ? "grid-cols-1" : isTablet ? "grid-cols-2" : "grid-cols-3"}`}
            >
                {visibleCourses.map((course) => (
                    <CourseCard
                        key={course.id}
                        course={{
                            ...course,
                            author: undefined,
                            duration: undefined,
                            topic: undefined,
                        }}
                    />
                ))}
            </div>
            <div className="flex justify-center mt-8">
                <Button
                    variant={ButtonVariant.PRIMARY}
                    text={t("educationalMaterials.courses.moreCourses")}
                    onClick={() => navigate("/courses")}
                />
            </div>
        </section>
    );
}
